import React from "react";
import {
  percentDecorator,
  chartTickPercentFormat,
} from "../../../../styles/cell-decorators";
import ChartComponent from "../../../../components/dashboard-components/chart-component/chart-component";

export default function CustomerInStockRateChartComponent(props) {
  return (
    <ChartComponent
      {...props}
      title={"Your In Stock Rates"}
      currentKey={"currentInStockRate"}
      previousKey={"previousInStockRate"}
      changeKey={"inStockRateDiff"}
      taglineSubject={"Your in stock rate"}
      legendName={"In Stock Rate"}
      valueDecorator={percentDecorator}
      yTickFormat={chartTickPercentFormat}
    />
  );
}
